import { useClipboard } from '@calendly/clipboard';
import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Grid, GridItem } from '@calendly/ui/components/grid';
import { CheckIcon, CopyIcon } from '@calendly/ui/components/icons';
import { TextInput } from '@calendly/ui/components/text-input';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const inputWrapperCss = "idfjg38";
const InputWrapper = forwardRef((props, ref) => <Grid ref={ref} {...props} className={classNames(inputWrapperCss, props.className)} />);
const copyWrapperCss = "c18hnu2h";
const CopyWrapper = forwardRef((props, ref) => <GridItem ref={ref} {...props} className={classNames(copyWrapperCss, props.className)} />);
const styledButtonCss = "smkcrwt";
const StyledButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(styledButtonCss, props.className)} />);
export const CardInput = ({
  value,
  inputName,
  label
}) => {
  const [Wrapper, ref, isCopied] = useClipboard(value);
  const onClickInput = e => {
    e.persist();
    // Safari won't select text unless we let it process its event queue first
    // See https://stackoverflow.com/questions/6201278/how-to-select-all-text-in-textarea-on-focus-in-safari
    setTimeout(() => e.target.select(), 0);
  };
  return <InputWrapper>
      <GridItem size="12">
        <label htmlFor={inputName}>
          <BodyText weight="bold">
            {label}
          </BodyText>
        </label>
      </GridItem>
      <GridItem size="8">
        <TextInput id={inputName} name={inputName} defaultValue={value} onClick={onClickInput} readOnly />
      </GridItem>
      <CopyWrapper size="4">
        <Wrapper>
          <StyledButton ref={ref} decoration="ghost">
            {isCopied ? <CheckIcon /> : <CopyIcon />}
            <BodyText inline>{I18n.t('publisher.organization_settings.domain_control.cards.copy_record')}</BodyText>
          </StyledButton>
        </Wrapper>
      </CopyWrapper>
    </InputWrapper>;
};

require("./input.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./input.js");